import { storeWrapper } from '../storeWrapper'
import { debounce } from '@repo/utils/debounce'
import { ospreyAPI } from '@repo/api/ospreyAPI'
import { useAuthenticationStore } from '@repo/store/useAuthenticationStore'

const initialState = {
  feeEarners: null,
  feeEarnersById: {},
  feeEarnerIds: null,
  feeEarner: null,
  supervisingFeeEarner: null
}

export const useFeeEarnerStore = storeWrapper('useFeeEarnerStore', (set, get) => ({
  ...initialState,
  fetchFeeEarners: async () => {
    debounce({
      id: `fetchFeeEarners`,
      delay: 300,
      callback: async () => {
        let feeEarners = await ospreyAPI({
          service: 'lookups',
          endpoint: 'FeeEarner/GetAll'
        })

        feeEarners = feeEarners.sort((a, b) => {
          if (a.description.toLowerCase() < b.description.toLowerCase()) {
            return -1
          }

          return 1
        })

        const feeEarnerIds = feeEarners.map((fe) => fe.feeEarnerId)

        const feeEarnerIdForCurrentUser = useAuthenticationStore.getState().feeEarnerId

        if (feeEarnerIdForCurrentUser) {
          // check the user's fee earner is in the list of active fee earners
          const feeEarnerForCurrentUser = feeEarners.find((fe) => fe.feeEarnerId === feeEarnerIdForCurrentUser)

          // add the current user to the top of the list, to make it easy to select
          if (feeEarnerForCurrentUser) {
            feeEarners.unshift(feeEarnerForCurrentUser)
          } else {
            // if the user's fee earner is not in the list, it isn't In Use, so we should remove it from the user's settings
            useAuthenticationStore.setState({ feeEarnerId: null, feeEarnerDescription: null })
          }
        }

        const feeEarnersById = {}
        feeEarners.forEach((feeEarner) => {
          feeEarnersById[feeEarner.feeEarnerId] = feeEarner
        })

        set({ feeEarners, feeEarnerIds, feeEarnersById })
      }
    })
  },
  fetchFeeEarnerById: async ({ feeEarnerId, forceApi = false }) => {
    if (forceApi) {
      const feeEarner = await ospreyAPI({
        service: 'lookups',
        endpoint: `FeeEarner/Get?id=${feeEarnerId}`
      })

      set({ feeEarner: feeEarner })
    } else {
      const selectedOption = get().feeEarners.find((feeEarner) => feeEarner.feeEarnerId === feeEarnerId)

      set({ feeEarner: selectedOption })
    }
  },
  fetchSupervisingFeeEarnerById: async ({ supervisingFeeEarnerId, forceApi = false }) => {
    if (forceApi) {
      const feeEarner = await ospreyAPI({
        service: 'lookups',
        endpoint: `FeeEarner/Get?id=${supervisingFeeEarnerId}`
      })

      set({ supervisingFeeEarner: feeEarner })
    } else {
      const selectedOption = get().feeEarners.find(
        (supervisingFeeEarner) => supervisingFeeEarner.feeEarnerId === supervisingFeeEarnerId
      )

      set({ supervisingFeeEarner: selectedOption })
    }
  },
  resetFeeEarner: () => set({ feeEarner: null }),
  resetSupervisingFeeEarner: () => set({ supervisingFeeEarner: null }),
  reset: () => set(initialState)
}))
